import { Box, Heading } from 'native-base';
import React, { useMemo } from 'react';

import BulletListItem from 'app/components/BulletListItem';
import HTML from 'app/components/HTML';
import { AttractionContent } from 'app/hooks/useAttraction';
import { useI18n } from 'app/providers/I18nProvider';

export type AttractionDetailsTipsAdviceProps = {
  attraction: NonNullable<AttractionContent>;
};

export default function AttractionDetailsTipsAdvice({
  attraction,
}: AttractionDetailsTipsAdviceProps) {
  const { t } = useI18n();
  const adviceSections = useMemo(() => {
    if (!attraction) return [];

    const sections = [];

    if (attraction.tips?.length) {
      sections.push({ title: t('gen_tips'), items: attraction.tips?.map((text) => text.value) });
    }

    if (attraction.amenities?.length) {
      sections.push({
        title: t('gen_amenities'),
        items: attraction.amenities?.map((text) => text.value),
      });
    }

    if (attraction.safety?.length) {
      sections.push({
        title: t('gen_visitor_safety'),
        items: attraction.safety?.map((text) => text.value),
      });
    }

    if (attraction.bestTime) {
      sections.push({
        title: t('gen_attraction_details_besttime_title'),
        items: [attraction.bestTime],
      });
    }

    if (attraction.accessibility) {
      sections.push({
        title: t('gen_attraction_details_accessibility_title'),
        items: [attraction.accessibility],
      });
    }

    return sections;
  }, [attraction, t]);

  return (
    <Box testID="AttractionDetailsTipsAdvice">
      {adviceSections.map(({ title, items }) => (
        <Box key={title}>
          <Heading fontSize="sm" mb="2">
            {title}
          </Heading>
          {items?.map((value) => (
            <BulletListItem key={value}>
              <HTML html={value} />
            </BulletListItem>
          ))}
        </Box>
      ))}
    </Box>
  );
}
